var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckList } from 'src/ui/components/Input/CheckList/CheckList';
import styles from './RequestedDocuments.module.scss';
export var RequestedDocuments = function (props) {
    var i18n = props.i18n, documentsToRequestByApplicant = props.documentsToRequestByApplicant, missingDocuments = props.missingDocuments, onMissingDocumentsChange = props.onMissingDocumentsChange;
    if (documentsToRequestByApplicant.length === 0) {
        return null;
    }
    var handleMissingDocumentChange = function (newMissingDocumentLabel, applicantId) {
        var _a;
        var documentsForApplicant = documentsToRequestByApplicant
            .find(function (item) { var _a; return ((_a = item.applicant) === null || _a === void 0 ? void 0 : _a.id) === applicantId; })
            .requestedDocuments.filter(function (item) { return newMissingDocumentLabel.indexOf(item.label) !== -1; });
        var newMissingDocument = __assign(__assign({}, missingDocuments), (_a = {}, _a[applicantId] = documentsForApplicant, _a));
        onMissingDocumentsChange(newMissingDocument);
    };
    return (_jsx("ul", __assign({ className: styles.requestedDocumentsWrapper }, { children: documentsToRequestByApplicant.map(function (applicantDocuments) {
            var _a;
            var applicant = applicantDocuments.applicant, requestedDocuments = applicantDocuments.requestedDocuments;
            var applicantId = (applicant === null || applicant === void 0 ? void 0 : applicant.id) || 'null';
            var missingDocForApplicant = (_a = missingDocuments[applicantId]) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.label; });
            var name = applicant ? "".concat(applicant.firstName, " ").concat(applicant.lastName) : null;
            return (_jsxs("li", __assign({ className: styles.requestedDocumentItemWrapper }, { children: [applicant && _jsx("p", __assign({ className: styles.requestedDocumentItemApplicant }, { children: name })), _jsx(CheckList, { i18n: i18n, options: requestedDocuments, currentOption: missingDocForApplicant || [], onChange: function (newMissingDocumentLabel) { return handleMissingDocumentChange(newMissingDocumentLabel, applicantId); }, className: styles.requestedDocumentChecklist })] }), applicantId));
        }) })));
};
